import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import type { AuditLog } from '@repo/api-gw-sdk';
import { AuditLogAuthStatus } from '@repo/api-gw-sdk';
const authResultLabels: Record<AuditLogAuthStatus, string> = {
  [AuditLogAuthStatus.Success]: 'Success',
  [AuditLogAuthStatus.Failure]: 'Failed',
  [AuditLogAuthStatus.InProgress]: 'In progress'
};

/**
 * The outcome of an authentication event. Only auth operations carry one, and it is not the
 * status code: a Cognito-sourced row's status code is synthesized from the outcome rather than
 * answered by a server, so reading the verdict off the code inverts the direction of truth.
 */
export const AuditLogAuthResultCell = t0 => {
  const $ = _c(2);
  const {
    log
  } = t0;
  const status = log.extendedData?.auth?.status;
  const t1 = status && authResultLabels[status] || "--";
  let t2;
  if ($[0] !== t1) {
    t2 = <Typography>{t1}</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};